/**
 * Container types enumeration
 * @enum {string}
 */
const ContainerTypes = Object.freeze({
  ALTERNATIVES: 'ALTERNATIVES',
  SIMILAR_PRODUCTS: 'SIMILAR_PRODUCTS',
  FEATURED: 'FEATURED',
  RECOMMENDED: 'RECOMMENDED',
  REGULAR: 'REGULAR',
  YOU_MIGHT_LIKE: 'YOU_MIGHT_LIKE',
});

export default ContainerTypes;
